/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { SortableContainer } from "react-sortable-hoc";
import JobSortListItem from "./JobSortListItem";

const SortableJobList = SortableContainer(
  ({ jobs, activeJobKey, activeJobId, changeActiveJob, removeJob }) => {
    const jobItems = jobs.map((job, index) => {
      let listItemClassName;
      if (activeJobId) {
        if (activeJobKey === "id") {
          listItemClassName =
            job.id === parseInt(activeJobId, 10)
              ? "list-group-item job-item active"
              : "list-group-item job-item";
        } else {
          listItemClassName =
            job.externalId === activeJobId
              ? "list-group-item job-item active"
              : "list-group-item job-item";
        }
      } else {
        listItemClassName = "list-group-item job-item";
      }
      const removable = jobs.length > 1

      return (
        <JobSortListItem
          key={job.externalId || job.id}
          index={index}
          job={job}
          listItemClassName={listItemClassName}
          changeActiveJob={changeActiveJob}
          removeJob={removeJob}
          removable={removable}
        />
      );
    });

    if (jobItems.length === 0) {
      jobItems.push(
        <div key={0} className="list-group-item job-item">
          This runsheet has no jobs
        </div>
      );
    }

    return <div className="list-group job-list">{jobItems}</div>;
  }
);

const SortableComponent = ({
  jobs,
  activeJobId,
  changeActiveJob,
  updateJobSequence,
  activeJobKey,
  removeJob
}) => (
  <div className="bg-white job-sort">
    <SortableJobList
      jobs={jobs}
      activeJobKey={activeJobKey}
      activeJobId={activeJobId}
      changeActiveJob={changeActiveJob}
      onSortEnd={updateJobSequence}
      removeJob={removeJob}
      useDragHandle
    />
  </div>
);
SortableComponent.propTypes = {
  jobs: PropTypes.array.isRequired,
  activeJobId: PropTypes.string,
  activeJobKey: PropTypes.string,
  changeActiveJob: PropTypes.func.isRequired,
  updateJobSequence: PropTypes.func.isRequired,
  removeJob: PropTypes.func.isRequired
};
SortableComponent.defaultProps = {
  activeJobId: "",
  activeJobKey: ""
};

export default SortableComponent;



// WEBPACK FOOTER //
// ./src/components/jobs/JobSortList.js